import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { ModuleStructure } from 'src/app/models/module-structure';
import { RecordModel } from 'src/app/layout/record-model';
import {
  Input,
  OnInit,
  Directive,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { CellSetting } from './cell-setting';
import { LayoutService } from './layout.service';
import * as g from 'src/app/globals';
import { ModuleInformation } from '../models/module-information';
import { RecordPageComponent } from './record-page/record-page.component';
import { ApprovalObject } from './Inbox/InboxInterfaces/approvalObject';
import { FormControl, FormGroup } from '@angular/forms';
import { ApprovalDecisionDialogComponent } from './general/approval-decision-dialog/approval-decision-dialog.component';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export class Cell implements OnInit {
  @ViewChild('ApprovaldrawerTemplate', { static: false })
  drawerTemplate?: TemplateRef<{
    $implicit: { value: string };
    drawerRef: NzDrawerRef<string>;
  }>;

  @Input() colData: any;
  @Input() value: any;
  @Input() row: number;
  @Input() cellSettings: CellSetting[];
  @Input() dataset: any[];
  @Input() tableName: string;
  @Input() linkedModule: number;
  @Input() linkedModuleField: string;
  @Input() keyName: string;
  @Input() keyValue: string;
  @Input() recordModel: RecordModel;
  @Input() moduleStructure: ModuleStructure;

  @Input() options: any;
  parentModuleName: string;
  prefix: string;

  ApprovalMessage: ApprovalObject;
  approvalForm: FormGroup;

  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    this.approvalForm = new FormGroup({
      AppRemark: new FormControl(),
      AppStatus: new FormControl(),
    });
  }

  ngOnInit(): void {
    //this.getOptions();
    if (this.colData.Type === 5) {
      if (this.value === 'N' || this.value === 'false') {
        this.dataset[this.row][this.colData.Name] = 'false';
      } else {
        this.dataset[this.row][this.colData.Name] = 'true';
      }
    } else if (this.colData.Type === 12) {
      if (this.linkedModuleField === '' || this.linkedModuleField === null) {
        this.prefix = '';
      } else {
        const module = g.modulesData.find(
          (m) =>
            (this.colData.ModuleID === 'ModuleId' &&
              m.id === Number(this.linkedModuleField)) ||
            (this.colData.ModuleID !== 'ModuleId' &&
              m.objType === this.linkedModuleField &&
              (this.recordModel === undefined ||
                (this.recordModel !== undefined &&
                  m.app === this.recordModel.ModuleApp)))
        );

        if (module !== undefined && this.colData.ModuleID !== 'ModuleId') {
          this.prefix = this.layoutService.translate(module.name) + ' - ';
        }
      }
    }
  }

  /*ngAfterViewInit() {
    setTimeout(() => {
      this.getOptions();
      if (this.colData.Type === 5) {
        console.log('herer');
        if (this.value === 'N' || this.value === 'false') {
          this.dataset[this.row][this.colData.Name] = 'false';
        } else {
          this.dataset[this.row][this.colData.Name] = 'true';
        }
      }
    }, 1);
  }*/

  valueChanged($event) {
    this.layoutService.triggerCellValueChanged({
      row: this.row,
      column: this.colData,
      dataset: this.dataset,
      name: this.tableName,
      moduleStructure: this.moduleStructure,
      recordModel: this.recordModel,
    });
  }

  GetDisabledValue(): boolean {
    if (this.cellSettings === undefined) {
      return true;
    }

    const index = this.cellSettings.findIndex(
      (c) => c.row === this.row && c.column === this.colData.Name
    );
    if (index === -1) {
      return this.colData.Mode === 1;
    } else {
      const cellSetting = this.cellSettings[index];
      return cellSetting.settings.readonly;
    }
  }

  getOptions() {
    if (
      this.colData === undefined ||
      this.colData.SQLStatementId === undefined ||
      this.colData.SQLStatementId === null
    ) {
      return;
    }

    const paramsNames = g.queriesData[this.colData.SQLStatementId];
    const vals: string[] = [];

    this.layoutService
      .getSelectValues(
        this.moduleStructure,
        '',
        0,
        this.colData.SQLStatementId,
        paramsNames,
        vals
      )
      .subscribe((d: any) => {
        this.options = d.Values.rowsArray;
      });
  }

  openModuleDetail() {
    if (this.colData.ModuleID === 'APPROVAL_DIALOG') {
      this.openApproval();
    } else {
      const linkedModule = this.linkedModule;
      if (
        linkedModule === undefined ||
        linkedModule == null ||
        linkedModule === 0
      ) {
        let module = g.modulesData.find(
          (m) =>
            (this.colData.ModuleID === 'ModuleId' &&
              m.id === Number(this.linkedModuleField)) ||
            (this.colData.ModuleID !== 'ModuleId' &&
              m.objType === this.linkedModuleField &&
              (this.recordModel === undefined ||
                (this.recordModel !== undefined &&
                  m.app === this.recordModel.ModuleApp)))
        );

        if (module !== undefined) {
          this.linkedModule = module.id;
        }

        if (module === undefined) {
          module = g.modulesData.find(
            (m) =>
              (this.colData.ModuleID === 'ModuleId' &&
                m.systemId === Number(this.linkedModuleField)) ||
              (this.colData.ModuleID !== 'ModuleId' &&
                m.objType === this.linkedModuleField &&
                (this.recordModel === undefined ||
                  (this.recordModel !== undefined &&
                    m.app === this.recordModel.ModuleApp)))
          );

          if (module !== undefined) {
            this.linkedModule = module.systemId;
          }
        }
      }

      this.layoutService
        .moduleInformation(this.linkedModule.toString())
        .subscribe((d: ModuleInformation) => {
          console.log('header data', d);
          this.parentModuleName = d.Name;
          let kValue = this.value;
          if (
            !(
              this.keyName === null ||
              this.keyName === '' ||
              this.keyName === undefined
            )
          ) {
            kValue = this.keyValue;
          }

          RecordPageComponent.openRecordPage(this.drawerService, {
            actionType: 'Edit',
            drawerTitle:
              this.layoutService.translate(
                `Details of ${this.parentModuleName}: `
              ) + this.value,
            inDrawer: true,
            moduleId: this.linkedModule,
            parentComponent: this,
            recordId: kValue,
            recordModel: undefined,
          });
        });
    }
  }

  openApproval() {
    let docEntry = this.value;
    if (
      !(
        this.keyName === null ||
        this.keyName === '' ||
        this.keyName === undefined
      )
    ) {
      docEntry = this.keyValue;
    }

    ApprovalDecisionDialogComponent.openTemplate(
      docEntry,
      'CELL',
      this.drawerService,
      this.layoutService
    );
  }
}
